// Invoke strict mode
"use strict";

/**
 * Object of DOM element references for the UI.
 *
 * @object ui
 */
var ui = {};

/**
 * Main object to namespace all application logic.
 *
 * @object app
 */
var app = {

  /**
   * Application-wide reference to events.
   *
   * @property app.events
   */
  events: new Events(),

  /**
   * Method to handle app initialization.
   */
  init: function() {

    // Fire the event to initialize the blocks
    app.events.emit("app.blocks.init");

    // TODO: Debate if this can be removed, handy for previewing
    bind(doms("a[href='#']"), "click", function(event) {
      event.preventDefault();
    });

    // TODO: Move to a generic form handler
    var form = document.querySelector(".form");
    if (form) {
      form.addEventListener("submit", app.handleFormSubmit);
      form.addEventListener("click", function(event) {
        if (event.target.id === "validate_order") {
          event.preventDefault();
          if (app.handleFormValidate(form)) {
            var submit = document.getElementById("place_order");
            if (submit) {
              submit.click();
            }
          }
        }
      });
    }

  },

  /**
   * Method to handle app load.
   */
  load: function() {

    // Start the animation on window load
    document.body.classList.add("animate");

  },

  /**
   * Method to handle form validation before submision.
   */
  handleFormSubmit: function(event) {

    var form = event.target;
    var valid = app.handleFormValidate(form);
    var submit = form.querySelector("button[type='submit']");

    if (!valid) {
      event.preventDefault();
    } else if (submit.dataset.formSubmitOnce === "") {
      // Prevent the user from submitting the form twice
      submit.innerHTML = submit.dataset.labelSubmitting;
      submit.classList.add("disabled");
      submit.style.pointerEvents = "none";
      submit.blur();
    }

  },

  /**
   * Method to handle form validation before submision.
   */
  handleFormValidate: function(form) {

    var valid = true;
    var isCheckout = form.classList.contains("checkout");

    for (var index = 0; index < form.elements.length; index++) {

      var element = form.elements[index];
      var tag = element.tagName.toLowerCase()

      if (tag !== "input" && tag !== "select" && tag !== "textarea") {
        continue;
      }

      var name = element.name;
      var value = element.value;
      var required = element.getAttribute("aria-required") === "true"

      if (isCheckout && name.indexOf("shipping_") === 0) {
        var shipto = document.getElementById("ship-to-different-address-checkbox");
        if (shipto && !shipto.checked) {
          required = false;
        }
      }

      var invalid = required && value === "";

      if (!required) {
        element.classList.toggle("form-input-invalid", invalid);
        continue;
      }

      if (!invalid && element.type === "email") {
        var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!regex.test(value.toLowerCase())) {
          invalid = true;
        }
      }

      if (!invalid && element.type === "tel") {
        var regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        if (!regex.test(value)) {
          invalid = true;
        }
      }

      if (!invalid && element.type === "password") {
        var passwords = form.querySelectorAll("input[type='password']");
        var password = "";
        // Ensure they are the same
        if (passwords.length === 2) {
          for (var i = 0; i < passwords.length; i++) {
            if (password === "") {
              password = passwords[i].value;
            } else {
              if (password !== passwords[i].value) {
                invalid = true;
              }
            }
          }
          // Ensure requirements (6 chars, number, upper, lower, special)
          var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{6,}$/;

          if (!regex.test(password)) {
            invalid = true;
          }
        }
      }

      element.classList.toggle("form-input-invalid", invalid);

      if (invalid) {
        valid = false;
      }

    }

    return valid;

  },

};

// Bind the app initialization to the DOM content loaded event
window.addEventListener("DOMContentLoaded", app.init.bind(app));

// Bind the app load to the window loaded event
window.addEventListener("load", app.load.bind(app));

// Google Tag Manager
// TODO: Move the GTM code to a common config
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag("js", new Date());
gtag("config", "GTM-PL5BFVH");
